import { I18n } from 'i18n/types'
import { RoomFilterType } from './types'

export const getTimeRounded = (i18n: I18n, time: number) => {
  const roundedTime = Math.round(time / 60)

  if (roundedTime < 1) {
    return i18n.t('screens.cartography.destinationNear')
  }
  return i18n.t('screens.cartography.itineraryTime', { count: roundedTime })
}

export const getDistanceRounded = (i18n: I18n, distance: number) => {
  const roundedDistance = Math.round(distance)

  return i18n.t('screens.cartography.itineraryDistance', { count: roundedDistance })
}

export const getRoomTypeEnum = (roomType: string): RoomFilterType => {
  const type = roomType.toLowerCase()

  switch (type) {
    case 'salle de réunion':
    case 'meeting room':
      return RoomFilterType.MEETING_ROOM
    case 'bureau':
    case 'desk':
      return RoomFilterType.OFFICE
    case 'rie':
    case 'restaurant':
      return RoomFilterType.RESTAURANT
    default:
      return RoomFilterType.ALL
  }
}
